import React from 'react';
import CommonSVGIcon, { Props } from './CommonSVGIcon';

export default function MarkerIcon(props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 24 24">
      <path d="M11.7935 19.0869C15.7639 19.0869 19.0869 15.7639 19.0869 11.7935C19.0869 7.81348 15.7639 4.5 11.7839 4.5C7.80396 4.5 4.5 7.81348 4.5 11.7935C4.5 15.7639 7.81348 19.0869 11.7935 19.0869Z" />
    </CommonSVGIcon>
  );
}

/*
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.7935 19.0869C15.7639 19.0869 19.0869 15.7639 19.0869 11.7935C19.0869 7.81348 15.7639 4.5 11.7839 4.5C7.80396 4.5 4.5 7.81348 4.5 11.7935C4.5 15.7639 7.81348 19.0869 11.7935 19.0869Z" fill="#00875A"/>
</svg>
*/